<!-- @format -->

<template>
  <el-dialog :title="$t('addOwnerMember.title')" :visible.sync="dialogVisible" width="60%" @close="_closeSaveOwnerModal">
    <el-form :model="addOwnerMemberInfo" :rules="rules" ref="form" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('addOwnerMember.personRole')" prop="personRole">
            <el-select v-model="addOwnerMemberInfo.personRole" :placeholder="$t('addOwnerMember.placeholder.personRole')" class="w100">
              <el-option v-for="item in roleOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('addOwnerMember.name')" prop="name">
            <el-input v-model.trim="addOwnerMemberInfo.name" :placeholder="$t('addOwnerMember.placeholder.name')" clearable />
          </el-form-item>

          <el-form-item :label="$t('addOwnerMember.link')" prop="link">
            <el-input v-model.trim="addOwnerMemberInfo.link" :placeholder="$t('addOwnerMember.placeholder.link')" clearable />
          </el-form-item>

          <el-form-item :label="$t('addOwnerMember.sex')" prop="sex">
            <el-select v-model="addOwnerMemberInfo.sex" :placeholder="$t('addOwnerMember.placeholder.sex')" class="w100">
              <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12" class="text-center">
          <div class="avatar-uploader" v-if="addOwnerMemberInfo.ownerPhotoUrl == '' && hasCamera">
            <!-- 摄像头预览 -->
            <video ref="video" autoplay playsinline width="320" height="160"></video>
            <!-- 拍下来的照片预览 -->
            <canvas ref="canvas" style="display: none"></canvas>
          </div>
          <div class="avatar-uploader" v-else>
            <img v-if="addOwnerMemberInfo.ownerPhotoUrl" :src="addOwnerMemberInfo.ownerPhotoUrl" class="avatar" :alt="$t('addOwnerMember.photo')" />
            <img v-else src="/img/noPhoto.jpg" class="avatar" :alt="$t('addOwnerMember.photo')" />
          </div>
          <el-button v-show="hasCamera" type="primary" icon="el-icon-camera" class="mt10" @click="takePhoto">
            {{ $t("addOwnerMember.takePhoto") }}
          </el-button>
          <el-button type="primary" class="mt10" @click="_uploadPhoto">
            {{ $t("addOwnerMember.uploadPhoto") }}
          </el-button>
          <input type="file" ref="fileInput" accept=".jpg,.jpeg,.png" @change="_choosePhoto" style="display: none" />
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('addOwnerMember.concactLink')">
            <el-input v-model.trim="addOwnerMemberInfo.concactLink" :placeholder="$t('addOwnerMember.placeholder.concactLink')" clearable />
          </el-form-item>

          <el-form-item :label="$t('addOwnerMember.address')">
            <el-input v-model.trim="addOwnerMemberInfo.address" :placeholder="$t('addOwnerMember.placeholder.address')" clearable />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('addOwnerMember.idCard')">
            <el-input v-model.trim="addOwnerMemberInfo.idCard" :placeholder="$t('addOwnerMember.placeholder.idCard')" clearable />
          </el-form-item>

          <el-form-item :label="$t('addOwnerMember.remark')">
            <el-input v-model.trim="addOwnerMemberInfo.remark" :placeholder="$t('addOwnerMember.placeholder.remark')" clearable />
          </el-form-item>
        </el-col>
      </el-row>

      <template v-for="(item, index) in addOwnerMemberInfo.attrs">
        <el-row :gutter="20" v-if="index % 2 === 0" :key="index">
          <el-col :span="12">
            <el-form-item :label="item.specName" v-if="item.specType === '2233'">
              <el-input v-model="item.value" :placeholder="item.specHoldplace" clearable />
            </el-form-item>

            <el-form-item :label="item.specName" v-if="item.specType === '3344'">
              <el-select v-model="item.value" :placeholder="item.specHoldplace" class="w100">
                <el-option v-for="value in item.values" :key="value.value" :label="value.valueName" :value="value.value" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="index < addOwnerMemberInfo.attrs.length - 1">
            <el-form-item :label="addOwnerMemberInfo.attrs[index + 1].specName" v-if="addOwnerMemberInfo.attrs[index + 1].specType === '2233'">
              <el-input v-model="addOwnerMemberInfo.attrs[index + 1].value" :placeholder="addOwnerMemberInfo.attrs[index + 1].specHoldplace" clearable />
            </el-form-item>

            <el-form-item :label="addOwnerMemberInfo.attrs[index + 1].specName" v-if="addOwnerMemberInfo.attrs[index + 1].specType === '3344'">
              <el-select v-model="addOwnerMemberInfo.attrs[index + 1].value" :placeholder="addOwnerMemberInfo.attrs[index + 1].specHoldplace" class="w100">
                <el-option v-for="value in addOwnerMemberInfo.attrs[index + 1].values" :key="value.value" :label="value.valueName" :value="value.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="_closeSaveOwnerModal">{{ $t("common.cancel") }}</el-button>
      <el-button type="primary" @click="saveOwnerMemberInfo">{{ $t("common.save") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCommunityId } from "@/api/community/communityApi";
import { getAttrValue } from "@/api/owner/ownerApi";
import { uploadFile } from "@/api/staff/addStaffApi";
import { getAttrSpecList } from "@/api/dev/attrSpecApi";
import { saveOwnerMember } from "@/api/owner/addOwnerMemberApi";

export default {
  name: "AddOwnerMember",
  data() {
    return {
      dialogVisible: false,
      addOwnerMemberInfo: {
        name: "",
        link: "",
        address: "",
        sex: "",
        remark: "",
        ownerId: "",
        ownerPhoto: "",
        ownerPhotoUrl: "",
        idCard: "",
        personType: "P",
        personRole: "3",
        concactLink: "",
        attrs: [],
      },
      roleOptions: [
        { value: "2", label: this.$t("addOwnerMember.role.tenant") },
        { value: "3", label: this.$t("addOwnerMember.role.family") },
        { value: "4", label: this.$t("addOwnerMember.role.staff") },
        { value: "99", label: this.$t("addOwnerMember.role.other") },
      ],
      sexOptions: [
        { value: "0", label: this.$t("common.male") },
        { value: "1", label: this.$t("common.female") },
      ],
      rules: {
        personRole: [{ required: true, message: this.$t("addOwnerMember.placeholder.personRole"), trigger: "change" }],
        name: [
          { required: true, message: this.$t("addOwnerMember.placeholder.name"), trigger: "blur" },
          { min: 2, max: 64, message: this.$t("addOwnerMember.validate.nameLength"), trigger: "blur" },
        ],
        link: [
          { required: true, message: this.$t("addOwnerMember.placeholder.link"), trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t("addOwnerMember.validate.phoneFormat"), trigger: "blur" },
        ],
        sex: [{ required: true, message: this.$t("addOwnerMember.placeholder.sex"), trigger: "change" }],
        idCard: [{ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: this.$t("addOwnerMember.validate.idCardFormat"), trigger: "blur" }],
        remark: [{ max: 200, message: this.$t("addOwnerMember.validate.remarkLength"), trigger: "blur" }],
      },
      stream: null, // 摄像头视频流
      hasCamera: false, // 是否支持摄像头
    };
  },
  methods: {
    loadImageFromBlob(blob) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(blob)
        const img = new Image()
        img.onload = () => {
          URL.revokeObjectURL(url)
          resolve(img)
        }
        img.onerror = (e) => {
          URL.revokeObjectURL(url)
          reject(e)
        }
        img.src = url
      })
    },
    canvasToJpegBlob(canvas, quality) {
      return new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), 'image/jpeg', quality)
      })
    },
    scaleDownCanvas(sourceCanvas, ratio) {
      const targetCanvas = document.createElement('canvas')
      targetCanvas.width = Math.max(1, Math.round(sourceCanvas.width * ratio))
      targetCanvas.height = Math.max(1, Math.round(sourceCanvas.height * ratio))
      const ctx = targetCanvas.getContext('2d')
      ctx.drawImage(sourceCanvas, 0, 0, targetCanvas.width, targetCanvas.height)
      return targetCanvas
    },
    async compressJpegFile(file, { maxBytes = 100 * 1024, maxDimension = 1080 } = {}) {
      if (!file || !(file instanceof Blob)) return file
      if (file.type === 'image/jpeg' && file.size <= maxBytes) return file

      const img = await this.loadImageFromBlob(file)

      const canvas = document.createElement('canvas')
      const iw = img.naturalWidth || img.width
      const ih = img.naturalHeight || img.height
      const scale = Math.min(maxDimension / iw, maxDimension / ih, 1)
      canvas.width = Math.max(1, Math.round(iw * scale))
      canvas.height = Math.max(1, Math.round(ih * scale))

      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

      let quality = 0.9
      let blob = await this.canvasToJpegBlob(canvas, quality)

      while (blob && blob.size > maxBytes && quality > 0.15) {
        quality = Math.max(0.15, quality - 0.1)
        blob = await this.canvasToJpegBlob(canvas, quality)
      }

      let workingCanvas = canvas
      while (blob && blob.size > maxBytes && (workingCanvas.width > 320 || workingCanvas.height > 320)) {
        workingCanvas = this.scaleDownCanvas(workingCanvas, 0.9)
        quality = Math.min(quality, 0.8)
        blob = await this.canvasToJpegBlob(workingCanvas, quality)
        while (blob && blob.size > maxBytes && quality > 0.15) {
          quality = Math.max(0.15, quality - 0.1)
          blob = await this.canvasToJpegBlob(workingCanvas, quality)
        }
      }

      const finalBlob = blob && blob.size ? blob : file
      const name = typeof file.name === 'string' && file.name ? file.name.replace(/\.[^/.]+$/, '') + '.jpg' : 'photo.jpg'
      return new File([finalBlob], name, { type: 'image/jpeg' })
    },
    // 初始化摄像头
    async startCamera() {
      try {
        // 基础兼容性判断
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          this.$message && this.$message.error("当前浏览器不支持摄像头调用");
          return;
        }

        // 先检测当前设备是否存在摄像头
        if (!navigator.mediaDevices.enumerateDevices) {
          // 某些非常老的浏览器没有 enumerateDevices，只能直接尝试 getUserMedia
          this.$message && this.$message.warning("无法检测摄像头设备，直接尝试打开摄像头");
        } else {
          const devices = await navigator.mediaDevices.enumerateDevices();
          const hasCamera = devices.some((d) => d.kind === "videoinput");

          if (!hasCamera) {
            // this.$message && this.$message.error("未检测到摄像头设备");
            this.hasCamera = false;
            return;
          }
        }

        // 注意：video 在 template 里被 v-if 控制，必须等 DOM 渲染出来再取 ref。
        // 第一次可能因为权限弹窗很慢“刚好没问题”，第二次 getUserMedia 很快就会踩到这里。
        this.hasCamera = true;
        await this.$nextTick();

        // 请求摄像头权限（可根据需求设置前后摄像头）
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" }, // 前置可用 'user'
          audio: false,
        });

        const video = this.$refs.video;
        if (!video) {
          // 理论上不应发生：兜底避免抛 TypeError 被当成“权限/设备问题”。
          console.warn("video ref 未就绪，无法挂载摄像头流");
          return;
        }

        if ("srcObject" in video) {
          video.srcObject = this.stream;
        } else {
          // 旧浏览器兼容
          video.src = window.URL.createObjectURL(this.stream);
        }
        video.play();
      } catch (err) {
        console.error("打开摄像头失败", err);

        // 根据错误类型给更友好的提示
        if (err.name === "NotFoundError" || err.name === "OverconstrainedError") {
          this.$message && this.$message.error("未检测到可用的摄像头");
        } else if (err.name === "NotAllowedError" || err.name === "SecurityError") {
          this.$message && this.$message.error("摄像头权限被拒绝，请在浏览器中开启权限");
        } else {
          this.$message && this.$message.error("打开摄像头失败，请检查设备和权限");
        }
      }
    },
    stopCamera() {
      // 1. 停止所有 track
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
      }

      // 2. 清理 video
      const video = this.$refs.video;
      if (video) {
        if ("srcObject" in video) {
          video.srcObject = null;
        } else {
          video.src = "";
        }
        video.pause && video.pause();
      }
    },
    // 拍照 / 重新拍照
    takePhoto() {
      // 若当前已经有照片：点击“拍照”= 重新拍照（清空旧图 -> 展示预览 -> 重启摄像头）
      if (this.addOwnerMemberInfo.ownerPhotoUrl) {
        if (!this.hasCamera) return;

        this.addOwnerMemberInfo.ownerPhoto = "";
        this.addOwnerMemberInfo.ownerPhotoUrl = "";

        // 允许重复选择同一文件（上传照片后也可再选同一张）
        if (this.$refs.fileInput) this.$refs.fileInput.value = "";

        // 先停再启，避免部分浏览器占用摄像头导致 getUserMedia 失败
        this.stopCamera();
        this.$nextTick(() => this.startCamera());
        return;
      }

      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      if (!video || !canvas) return;

      const vw = video.videoWidth;
      const vh = video.videoHeight;
      if (!vw || !vh) {
        console.warn("无法获取视频分辨率");
        return;
      }

      const maxSize = 1080; // 限制最大宽高

      // 计算等比例缩放比例，保证宽高都不超过 1080
      const scale = Math.min(maxSize / vw, maxSize / vh, 1);

      const targetW = Math.round(vw * scale);
      const targetH = Math.round(vh * scale);

      // 设置 canvas 的内部绘制尺寸（真实图片尺寸）
      canvas.width = targetW;
      canvas.height = targetH;

      const ctx = canvas.getContext("2d");
      // 把当前视频帧画到指定大小
      ctx.drawImage(video, 0, 0, targetW, targetH);

      // 转成 Blob
      canvas.toBlob(
        (blob) => {
          if (!blob) return;
          // 如果 _doUploadImage 需要 File：
          const file = new File([blob], "photo.jpg", { type: "image/jpeg" });
          this._doUploadImage(file);
          this.stopCamera(); // 拍照后停止摄像头
        },
        "image/jpeg",
        0.8
      );
    },

    open(params) {
    console.log("open", params);
      this.addOwnerMemberInfo.ownerId = params.ownerId;
      this._loadOwnerAttrSpec();
      this.dialogVisible = true;
      this.$nextTick(async () => {
        this.$refs.form.clearValidate();
        await this.startCamera();
      });
    },

    async saveOwnerMemberInfo() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            ...this.addOwnerMemberInfo,
            communityId: getCommunityId(),
          };
          saveOwnerMember(params)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success(this.$t("common.operationSuccess"));
                this.dialogVisible = false;
                this.$emit("success");
              } else {
                this.$message.error(res.msg || this.$t("common.saveFailed"));
              }
            })
            .catch((err) => {
              console.error("请求失败:", err);
              this.$message.error(this.$t("common.saveFailed"));
            });
        }
      });
    },

    async _loadOwnerAttrSpec() {
      this.addOwnerMemberInfo.attrs = [];
      const { data } = await getAttrSpecList({ page: 1, row: 100, tableName: "building_owner_attr" });
      for (const attr of data) {
        attr.value = "";
        if (attr.specShow == "Y") {
          attr.values = await getAttrValue(attr.specCd);
          this.addOwnerMemberInfo.attrs.push(attr);
        }
      }
    },

    _uploadPhoto() {
      this.$refs.fileInput.click();
    },

    _choosePhoto(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        const file = files[0];
        if (file.size > 1024 * 1024 * 2) {
          this.$message.error(this.$t("addOwnerMember.validate.photoSize"));
          return;
        }
        this._doUploadImage(file);
      }
    },

    async _doUploadImage(file) {
      try {
        const compressedFile = await this.compressJpegFile(file, { maxBytes: 100 * 1024, maxDimension: 1080 })
        const formData = new FormData()
        formData.append('uploadFile', compressedFile)
        formData.append('communityId', getCommunityId())

        const res = await uploadFile(formData)
        this.addOwnerMemberInfo.ownerPhoto = res.fileId
        this.addOwnerMemberInfo.ownerPhotoUrl = res.url
      } catch (err) {
        console.error('上传失败:', err)
        this.$message.error(this.$t('addOwnerMember.uploadFailed'))
      }
    },

    _closeSaveOwnerModal() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.addOwnerMemberInfo = {
        name: "",
        link: "",
        address: "",
        sex: "",
        remark: "",
        ownerId: "",
        ownerPhoto: "",
        ownerPhotoUrl: "",
        idCard: "",
        personType: "P",
        personRole: "3",
        concactLink: "",
        attrs: [],
      };
      this.stopCamera();
    },
  },
};
</script>

<style scoped>
.w100 {
  width: 100%;
}

.mt10 {
  margin-top: 10px;
}

.text-center {
  text-align: center;
}

.avatar-uploader {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.avatar {
  width: 150px;
  height: 150px;
  object-fit: cover;
}
</style>
